// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_EmployeeLastPeriodResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/employee_last_period
 * Returns the latest payroll period for a user+franchise combination (or null if none exists)
 */
import type { Payroll_PeriodRow } from './Payroll_PeriodRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_EmployeeLastPeriodResponseDados = Payroll_PeriodRow;

export type Payroll_EmployeeLastPeriodResponse = ApiResponse<Payroll_EmployeeLastPeriodResponseDados>;

registerResponseContract('Payroll_EmployeeLastPeriodResponse', {
  _nullable:                    { type: 'boolean', required: false },
  id:                           { type: 'number',  required: true },
  franchise_id:                 { type: 'number',  required: true },
  user_id:                      { type: 'string',  required: true },
  period_start_date:            { type: 'string',  required: true },
  period_end_date:              { type: 'string',  required: true },
  revenue_conciliation_amount:  { type: 'string',  required: true },
  expenses_conciliation_amount: { type: 'string',  required: true },
  status:                       { type: 'number',  required: true },
  total_amount:                 { type: 'string',  required: true },
  created_at:                   { type: 'string',  required: true },
  updated_at:                   { type: 'string',  required: true },
  calculated_at:                { type: 'string',  required: false },
  paid_at:                      { type: 'string',  required: false },
  paid_by:                      { type: 'string',  required: false },
  franchise_name:               { type: 'string',  required: false },
})
